<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="教师姓名">
              <a-input v-decorator="['name']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="年级科目"
            >
              <a-tree-select
                v-decorator="['userSubject']"
                :treeData="treeData"
                :replaceFields="{
                  children: 'jtypes',
                  title: 'name',
                  key: 'id',
                  value: 'id'
                }"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-button
              type="primary"
              icon="search"
              @click="$refs.table.refresh(true)"
              >查询
            </a-button>
            <a-button
              type="default"
              icon="reload"
              style="margin-left:8px"
              @click="handleReset"
              >重置
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleInsert">新增</a-button>
      <a-button type="default" icon="delete" @click="handleDel">删除</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      :alert="true"
      :rowSelection="rowSelection"
      showPagination="auto"
    >
      <template slot="serial" slot-scope="value, row, index">
        {{ index + 1 }}
      </template>

      <template slot="actions" slot-scope="text, record">
        <a @click="handleEdit(record)">修改</a>
        <a-divider type="vertical" />
        <a @click="handleDetail(record)">查看</a>
      </template>
    </s-table>

    <edit ref="edit" @ok="$refs.table.refresh(false)" />
    <detail ref="detail" />
  </a-card>
</template>
<script>
import { STable } from "@/components";
import edit from "./modules/edit";
import detail from "./modules/detail";
import { teacherFindPage as findPage, del } from "@/api/system/user";
import { trees } from "@/api/base/tree/manager";

const columns = [
  {
    title: "#",
    scopedSlots: { customRender: "serial" }
  },
  {
    title: "教师姓名",
    dataIndex: "name"
  },
  // {
  //   title: "年级",
  //   dataIndex: "grade"
  // },

  {
    title: "科目",
    ellipsis: true,
    dataIndex: "subjectNames",
    customRender: v => {
      return v ? v.replace(/\[|]/g, "") : "";
    }
  },
  {
    title: "角色",
    dataIndex: "roleName"
  },
  {
    title: "联系方式",
    dataIndex: "mobile"
  },
  {
    title: "操作",
    dataIndex: "actions",
    width: "150px",
    scopedSlots: { customRender: "actions" }
  }
];

export default {
  components: {
    STable,
    edit,
    detail
  },
  data() {
    this.columns = columns;
    return {
      //form
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        const requestParameters = Object.assign(
          params,
          this.queryParam,
          this.form.getFieldsValue()
        );
        if (requestParameters.userSubject) {
          requestParameters.userSubject = requestParameters.userSubject.toString();
        }

        return findPage(requestParameters).then(res => {
          return res.result;
        });
      },
      selectedRowKeys: [],
      selectedRows: [],

      // 年级科目
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      treeData: []
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      };
    }
  },

  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.loadTrees();
    },

    // 加载资源目录树
    loadTrees() {
      trees().then(res => {
        this.treeData = res.result;

        // this.filterThree();

        this.filterGradeDisabledAttr(this.treeData);
      });
    },

    // 获取三情分析数据
    filterThree() {
      // 只需要三情分析中的数据
      let data = this.treeData.filter(item => {
        return "三情分析" == item.name;
      });
      if (data.length) {
        this.treeData = data[0].jtypes;
      }
    },

    // 过滤，只需要年级以上的数据
    filterGradeDisabledAttr(items) {
      // console.log(" === teacher filtrGradeDisabledAttr === ");

      let _this = this;
      items.map(item => {
        // item.disabled = 0 == item.leveal ? true : false;

        // 只显示到科目
        if (3 == item.leveal) {
          item.jtypes = [];
        } else if (0 != item.leveal || 0 != item.jtypes.length) {
          item.selectable = false;
        }

        if (item.jtypes) {
          _this.filterGradeDisabledAttr(item.jtypes);
        }
      });
    },

    //重置
    handleReset() {
      this.form.resetFields();
    },
    handleInsert() {
      this.$refs.edit.show();
    },
    handleEdit(record) {
      record.treeData = this.treeData;
      this.$refs.edit.show(record);
    },
    // grid选择改变时触发事件
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    handleDetail(record) {
      console.log(" === handleDetail === ", record);
      this.$refs.detail.show(record);
    },
    // 删除
    handleDel() {
      // console.log("=== handleDel ===", this.selectedRowKeys, this.selectedRows);

      let that = this;
      let params = { userIdStrs: this.selectedRowKeys.toString(), status: "D" };
      this.$confirm({
        title: "提示",
        content: "是否确认删除该教师?",
        onOk() {
          that.loading = true;
          del({ ...params }).then(res => {
            if (res.resultCode === 1) {
              that.$notification.success({ message: res.message });
            } else {
              that.$notification.error({ message: res.message });
            }
            that.$refs.table.refresh(true);
          });
        }
      });
    }
  }
};
</script>
<style></style>
